import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { media as customMedia } from '@common/theme';
import SectionContainer from '@common/components/SectionContainer';
import { token } from 'odyssey';

type Alignment = 'left' | 'center' | 'centerAlt';

export const SolidColorBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.tertiaryColour};
  opacity: 0.8;
  min-height: 300px;
`;

export const FormWrapper = styled.div<{ alignment: Alignment }>`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0rem 1rem 0rem 1rem;

  ${media.md`
    padding: 4rem 1rem;
    min-height: 590px;
    align-items: ${({ alignment }: any) =>
      alignment === 'center' || alignment === 'centerAlt' ? 'center' : 'flex-start'}
  `}
`;

export const StyledHero = styled.div<{ darkenBackdrop?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  backdrop-filter: ${({ darkenBackdrop }) =>
    darkenBackdrop ? 'brightness(0.75)' : 'brightness(1)'};
  color: ${token('color-white')};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const PageTitle = styled.h1<{ alignment: Alignment }>`
  font-size: ${token('heading-1-hero-mb-font-size')};
  color: ${token('color-white')};
  text-shadow: 0px 3px 20px #000000;
  text-align: center;
  margin: 0;

  ${media.md`
    font-size: ${token('heading-1-hero-dt-font-size')};
    text-align: ${({ alignment }: any) =>
      alignment === 'center' || alignment === 'centerAlt' ? 'center' : 'left'};
  `};
`;

export const PageSubTitle = styled.h2<{ alignment: Alignment }>`
  margin: 0;
  text-shadow: 0px 3px 20px #000000;
  font-weight: ${token('font-weight-rg')};
  font-size: ${token('font-size-sm')};
  color: ${token('color-white')};
  text-align: center;
  font-family: ${({ theme }) => theme.bodyFont};

  ${media.md`
    font-size: ${token('font-size-md')};
    text-align: ${({ alignment }: any) =>
      alignment === 'center' || alignment === 'centerAlt' ? 'center' : 'left'};
  `}
`;

export const Divider = styled.div`
  margin: 1rem 0;

  ${media.md`
    display: flex;
    width: 250px;
    height: 1px;
    margin: 2rem 0;
    background: #ffffff;
  `}
`;

export const BackgroundWrapper = styled.div<{ isFiltersVisible?: boolean; alignment: Alignment }>`
  position: relative;
  margin-bottom: ${({ isFiltersVisible, theme }) =>
    isFiltersVisible ? '260px' : theme.spaces.space4};
  z-index: ${({ isFiltersVisible }) => (isFiltersVisible ? 10 : 5)};
  order: 0;

  > div {
    ${media.md`
      margin-bottom: 0px;
    `}

    display: grid;

    > div {
      display: grid;

      > div {
        display: grid;
        place-items: center;
      }
    }
  }

  ${media.md`
    margin-bottom: 0
  `}
`;

export const TitleContent = styled.div`
  max-width: 700px;
`;

export const SubTitleContent = styled.div`
  max-width: 700px;
`;

export const Search = styled.div<{ alignment: Alignment }>`
  justify-content: 'center';
  order: ${({ alignment }) => (alignment === 'centerAlt' ? 0 : 4)};
  width: 100%;
  max-width: 340px;
  text-align: center;
  flex-grow: ${({ alignment }) => alignment === 'centerAlt' && 2};
  padding: ${({ alignment }) => (alignment === 'centerAlt' ? '0' : '2rem 0')};

  ${media.md`
    margin-bottom: 0px;
  `}

  ${customMedia.desktop`
    max-width: 860px;
  `}
`;

export const Content = styled.div`
  margin-top: auto;
  max-width: 700px;
`;

export const StyledSectionContainer = styled(SectionContainer)``;

//OLD CONTENT REMOVE ONCE NEW DATE PICKER IS IMPLEMENTED EVERYWHERE
export const OldFormWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 300px;

  ${media.md`
    min-height: 590px;
    align-items: 'flex-start';
    max-width: fit-content;
  `}
`;

export const OldPageTitle = styled.h1`
  font-size: ${token('heading-1-hero-mb-font-size')};
  color: ${token('color-white')};
  text-shadow: 0px 3px 20px #000000;
  margin-bottom: 80px;
  text-align: left;

  ${media.md`
    margin-bottom: 20px;
    font-size: ${token('heading-1-hero-dt-font-size')};
  `}
`;
